import { useEffect, type ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router';
import { Splash } from '../shell/Splash';
import { restoreSession, useSession } from './session';

/** Schützt angemeldete Bereiche; stellt die Sitzung beim ersten Aufruf wieder her. */
export function AuthGate({ children }: { children: ReactNode }) {
  const status = useSession((s) => s.status);
  const unreachable = useSession((s) => s.unreachable);
  const location = useLocation();
  useEffect(() => {
    if (status === 'unknown') void restoreSession();
  }, [status]);
  if (status === 'unknown' || status === 'checking') return <Splash text={unreachable ? 'Server nicht erreichbar – neuer Versuch gleich …' : 'Sitzung wird geprüft …'} />;
  if (status === 'anonymous') {
    const next = location.pathname + location.search;
    return <Navigate to={`/login?next=${encodeURIComponent(next)}`} replace />;
  }
  return <>{children}</>;
}

/** Für Login/Registrierung: bereits angemeldete Nutzer weiterleiten. */
export function GuestOnly({ children }: { children: ReactNode }) {
  const status = useSession((s) => s.status);
  const unreachable = useSession((s) => s.unreachable);
  const location = useLocation();
  useEffect(() => {
    if (status === 'unknown') void restoreSession();
  }, [status]);
  if (status === 'unknown' || status === 'checking') return <Splash text={unreachable ? 'Server nicht erreichbar – neuer Versuch gleich …' : 'Sitzung wird geprüft …'} />;
  if (status === 'authenticated') {
    const next = new URLSearchParams(location.search).get('next');
    return <Navigate to={safeNext(next)} replace />;
  }
  return <>{children}</>;
}

/** Nur interne Pfade als Weiterleitungsziel (kein Open Redirect). */
export function safeNext(next: string | null): string {
  if (!next || !next.startsWith('/') || next.startsWith('//') || next.startsWith('/\\')) return '/channels/@me';
  return next;
}
